import { render, staticRenderFns } from "./gridDescription.vue?vue&type=template&id=ab5889fc&scoped=true"
import script from "./gridDescription.vue?vue&type=script&lang=js"
export * from "./gridDescription.vue?vue&type=script&lang=js"
import style0 from "./gridDescription.vue?vue&type=style&index=0&id=ab5889fc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab5889fc",
  null
  
)

export default component.exports